module.exports = __webpack_public_path__ + "static/media/camel-white.7eac11a2.png";